import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-black text-white py-10">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-center items-center mb-8">
          <div className="mb-6 md:mb-0">
            <Link to="/" className="flex items-center">
              <img 
                src="/logos/logo.png" 
                alt="$100K Agency" 
                className="h-8 md:h-10 w-auto object-contain" 
                style={{ 
                  maxWidth: '100%',
                  filter: 'drop-shadow(0 0 2px rgba(255, 255, 255, 0.2))'
                }}
              />
            </Link>
          </div>
          
          {/* Social media links removed */}
        </div>
        
        <div className="py-4 border-t border-gray-800">
          {/* Additional links removed */}
          <ul className="flex flex-wrap justify-center md:justify-start space-x-6">
            {/* Links removed */}
          </ul>
        </div>
        
        <div className="pt-6 text-xs text-gray-500 text-center">
          <p className="mb-2">*DISCLOSURE: All testimonials shown are real but we do not claim to represent typical results. Any financial information about the actual results of any client is their own. Your results will vary based on factors including (but not limited to) your implementation, your offer, your audience, your pricing, your execution, timing, luck, and a variety of other factors outside our control.</p>
          <p>© 2025 ignilead.com - All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 